<template>
  <div class="loading-container">
    <h1 class="loading-heading">Loading</h1>
    <img src="/images/spinner.png" alt="" class="loading-spinner" />
  </div>
</template>

<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 70px;
  height: 750px;
}

.loading-heading {
  color: #000;
  font-family: "Glusp";
  font-size: clamp(2.5rem, 3vw, 4.8rem);
  font-weight: 700;
}

.loading-spinner {
  height: 180px;
  width: auto;
  animation: spin 1.5s ease-in-out infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  .loading-spinner {
    height: 100px;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .loading-spinner {
    height: 130px;
  }
}

</style>